import {
  DEFAULT_ICON_CLASS_NAME,
  SECONDARY_ICON_CLASS_NAME,
  TEXT_FIELD_ICON_CLASS_NAME,
  NAVBAR_ICON_CLASS_NAME,
} from '../../constants/icon';
import { EVALUATION_SENT_DIALOG_ICON_CLASS_NAME } from '../../constants/dialog';
import FingoMuiSvgIcon from '../../fingo/components/MuiIcon';

const navbarIcon = ({ theme }) => ({
  color: theme.palette.common.white,
});

const evaluationSentDialogIcon = ({ theme }) => ({
  width: 40,
  height: 40,
  color: theme.palette.success.A700,
});

const MuiSvgIcon = {
  styleOverrides: {
    root: ({ theme }) => {
      const base = FingoMuiSvgIcon.styleOverrides.root({ theme });
      const accentIcon = { color: theme.palette.secondary.main };
      return {
        ...FingoMuiSvgIcon.styleOverrides.root({ theme }),
        [`&.${DEFAULT_ICON_CLASS_NAME}`]: accentIcon,
        [`&.${SECONDARY_ICON_CLASS_NAME}`]: accentIcon,
        [`&.${TEXT_FIELD_ICON_CLASS_NAME}`]: accentIcon,
        [`&.${EVALUATION_SENT_DIALOG_ICON_CLASS_NAME}`]: evaluationSentDialogIcon({ theme }),
        [`&.${NAVBAR_ICON_CLASS_NAME}`]: {
          ...base[`&.${NAVBAR_ICON_CLASS_NAME}`],
          ...navbarIcon({ theme }),
        },
      };
    },
  },
};

export default MuiSvgIcon;
